/*eslint-disable*/
import { useGet, usePut } from "./useRequest";
export const getCurrentCandidate = () => {
  const path = "/candidates/current";
  return useGet(path);
};

export const deleteCurrentCandidate = () => {
  const path = "/candidates/delete";
  return useGet(path);
};

export function getCurrentCandidateDocumentStatus() {
  const path = "/candidates/DocumentStatus";
  return useGet(path);
}

export function putCurrentCandidate(candidate) {
  const path = "/candidates/current";
  return usePut(path, candidate);
}